import * as React from "react";
import { Tabs } from "antd";
import { EmailListPage } from "./EmailListPage";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { Loader } from "Components/General/Loader";

interface TopicInboxState {
  data: API_MailInbox[];
  loading: boolean;
  activeKey: string;
}

export class TopicInbox extends React.Component<{}, TopicInboxState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      loading: false,
      data: [],
      activeKey: "",
    };
  }

  componentDidMount() {
    this.fetch();
  }

  fetch = async () => {
    try {
      this.setState({ loading: true });
      const response = await API.getData(API_URL.PROJECT_INBOXES.getProjectInboxList(projectsDataStore.projectId));
      const activeKey = response.length ? response[0].id.toString() : ""; // take first inbox as initial tab
      this.setState({ data: response, activeKey });
      if (activeKey) {
        this.handleTabClick(activeKey);
      }
    } catch (error) {
      throw error;
    } finally {
      this.setState({ loading: false });
    }
  };

  handleTabClick = (activeKey: string) => {
    this.setState({ activeKey });
  };

  render() {
    const { data, loading, activeKey } = this.state;

    if (loading) {
      return <Loader />;
    }

    return (
      <>
        <div style={{ marginTop: -20 }}>
          <Tabs
            activeKey={activeKey}
            onTabClick={this.handleTabClick}
            items={data.map((item) => ({
              key: item.id.toString(),
              label: item.name,
            }))}
          />
        </div>
        <EmailListPage
          emailType="INBOX"
          {...this.props}
          isProjectInbox={true}
          accessLevel="project"
          emailInboxId={activeKey}
        />
      </>
    );
  }
}
